import { createSelector } from 'reselect'
import config from 'constants/config'

export const OFFER_VIEWS_24_HOURS_THRESHOLD = config.OFFER_VIEWS_24_HOURS_THRESHOLD || 50
export const OFFER_PURCHASES_24_HOURS_THRESHOLD = config.OFFER_PURCHASES_24_HOURS_THRESHOLD || 2

export const getOfferExtra = createSelector(
  (state: App.State, offerId: string) => state.offer.offerExtras[offerId],
  (offerExtra) => offerExtra?.data,
)
